module.exports = __webpack_public_path__ + "static/Arun-Lingala-1525462aa49c092d1f20451851d95422.png";